<template>
    <div class="view-territories-modal">
        <el-dialog
            width='935px'
            :title= "translate('main_title')"
            :visible.sync='show'
            :close-on-click-modal='false'
            :before-close='close'
        >
            <div class="linked_territories_content">
                <el-table
                    :data="territories"
                    :empty-text="translate('no_data')"
                    highlight-current-row
                    v-loading="loadingTerritories"
                >
                    <el-table-column
                        min-width="156px"
                        prop="codigoTerritorioVega"
                        :label="translate('territory_lyra_code')"
                        label-class-name="transaction-list-table_label"
                    />
                    <el-table-column
                        v-if="transaction"
                        width="138px"
                        prop="volumeOrigemTon"
                        :label="translate('outbound_volume')"
                        label-class-name="transaction-list-table_label"
                    />
                    <el-table-column
                        v-if="transaction"
                        min-width="155px"
                        prop="volumeDestinoTon"
                        :label="translate('inbound_volume')"
                        label-class-name="transaction-list-table_label"
                    />
                    <el-table-column
                        v-if="warehouse || factory"
                        width="138px"
                        :label="translate('current_balance')"
                        label-class-name="transaction-list-table_label"
                    >
                        <template v-slot:default="scope">
                            {{ formatTonValue(scope.row.saldoAtualTon) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="warehouse || factory"
                        min-width="138px"
                        :label="translate('balance_in_transit')"
                        label-class-name="transaction-list-table_label"
                    >
                        <template v-slot:default="scope">
                            {{ formatTonValue(scope.row.saldoTransitoTon) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="150px"
                        prop="codigoProduto"
                        :label="translate('product')"
                        label-class-name="transaction-list-table_label"
                    >
                        <template v-slot:default="scope">
                            {{ translateProduct(scope.row.codigoProduto) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="175px"
                        prop="elegivel"
                        :label="translate('elegibility_analysis')"
                        label-class-name="transaction-list-table_label"
                        align="center"
                    >
                        <template v-slot:default="scope">
                            <el-tag v-if="scope.row.elegivel" class="tag-eligible" type="primary" size="small" :round="false">
                                {{ translate('eligible') }}
                            </el-tag>
                            <el-tag v-else class="tag-ineligible" type="primary" size="small" :round="false">
                                {{ translate('ineligible') }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="linked-territories-list-table__pagination">
                    <div class="total">
                        <span
                            >{{ totalElements }}
                            {{
                                translate('results')
                            }}</span
                        >
                        <div style="margin: 0 20px"></div>
                        <span
                            >{{
                                translate('view_by_page')
                            }}:</span
                        >
                        <el-pagination
                            @size-change="handleSizeChange"
                            :current-page="page"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="size"
                            layout="sizes"
                            :total="totalElements"
                        />
                    </div>
                    <div class="prev_next">
                        <el-pagination
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="size"
                            layout="prev, pager, next, jumper"
                            :total="totalElements"
                        />
                    </div>
                </div>
                <element class="linked-territories-modal-buttons">
                    <el-button type="secondary" @click="close">
                        <span>{{ $tc(`warehouse.messages.back`)}}</span>
                    </el-button>
                </element>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import RastreabilidadeTransacaoArmazemService from '@/services/RastreabilidadeTransacaoArmazemService';
import ArmazemModuleService from '@/services/ArmazemModuleService';
import IndustriaModuleService from '@/services/IndustriaModuleService';
import formatters from '@/utils/formatters';

export default {
    name: 'ViewTerritoriesModal',
    components: {
    },
    props: {
        show: {
            type: Boolean,
            required: true
        },
        transaction: {
            type: Object,
            required: false
        },
        warehouse: {
            type: Object,
            required: false
        },
        factory: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            territories: [],
            page: 0,
            size: 10,
            totalElements: 0,
            loadingTerritories: false
        };
    },
    mounted() {
        if (this.transaction || this.warehouse || this.factory) {
            this.getTerritories();
        }
    },
    computed: {
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.view_territories_modal';
            return this.$tc(`${base}.${key}`, params);
        },
        translateProduct(codigoProduto) {
            if (!codigoProduto) return '';
            const productKey = codigoProduto.toLowerCase();
            return this.$tc(`warehouse.table.product_codes.${productKey}`);
        },
        close() {
            this.$emit('close');
        },
        handleCurrentChange(page) {
            this.page = page;
            this.getTerritories();
        },
        handleSizeChange(size) {
            this.size = size;
            this.getTerritories();
        },
        async getTerritories() {
            if (this.transaction) {
                this.loadingTerritories = true;
                await RastreabilidadeTransacaoArmazemService.getTransactionTerritories(this.transaction.id, this.page - 1, this.size)
                .then(({ data }) => {
                    this.territories = data.itens;
                    this.totalElements = data.totalItens;
                    this.loadingTerritories = false;
                });
            }
            if (this.warehouse) {
                this.loadingTerritories = true;
                await ArmazemModuleService.getWarehouseTerritories(this.warehouse.idSaldo, this.page - 1, this.size)
                .then(({ data }) => {
                    this.territories = data.itens;
                    this.totalElements = data.totalItens;
                    this.loadingTerritories = false;
                });
            }
            if (this.factory) {
                this.loadingTerritories = true;
                await IndustriaModuleService.getFactoryTerritories(this.factory.id, this.page - 1, this.size)
                .then(({ data }) => {
                    this.territories = data.itens;
                    this.totalElements = data.totalItens;
                    this.loadingTerritories = false;
                });
            }
        },
        formatTonValue(value) {
            if (value !== 0 && (!value || value === '')) return '-';
            return formatters.minFormatNumber(value, 2, this.$i18n.locale);
        }
    },
    beforeDestroy() {
    }
};
</script>

<style scoped lang="scss">
.view-territories-modal {
    .linked_territories_content {
        padding: 16px 0;
    }

    .tag-eligible {
        background-color: #EBF4EB;
        border-radius: 4px !important;
        border: 1px solid #C0DDC1;
        color: #1F5B21;
    }
    .tag-ineligible {
        background-color: #FCEBEA;
        border-radius: 4px !important;
        border: 1px solid #F4C1BE;
        color: #991F1A;
    }
}

.linked-territories-list-table__pagination {
    display: grid;
    grid-template-columns: 2fr auto;
    margin: 20px 12px 0;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    .total {
        display: flex;
        align-items: center;
        @media (max-width: 768px) {
            flex-direction: column;
        }
    }

    .prev_next {
        display: flex;
        @media (max-width: 768px) {
            justify-content: center;
            margin-top: 20px;
        }
    }
}

.linked-territories-modal-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    button:first-child {
        margin-right: 10px;
    }
    button:last-child {
        margin-left: 10px;
    }
}
</style>
